
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom",
      function () {
        return require("private-next-pages/newsroom/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom"])
      });
    }
  